import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function Trash({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M3.11133 5.24463H20.8891"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.7998 5.24452V3.11119C8.7998 2.32612 9.43696 1.68896 10.222 1.68896H13.7776C14.5626 1.68896 15.1998 2.32612 15.1998 3.11119V5.24452"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7557 8.7998V19.4665C18.7557 21.038 17.4829 22.3109 15.9113 22.3109H8.08907C6.51752 22.3109 5.24463 21.038 5.24463 19.4665V8.7998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.51123 11.6445V18.0445"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4888 11.6445V18.0445"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
